<template>
  <div>
   <Header :title="title"/>
    <div class="footer_podat" v-if="kateg">
       <div class="main">
        <div align="center"><button class="btns" @click="dale()">Далее</button></div>
       </div>
    </div>

    <div class="content_podat">
      <div v-for="c in arr" :key="c.id" class="block_radio">
        <input
          class="custom-radio"
          name="color"
          v-model="kateg"
          type="radio"
          :id="c.id"
          :value="c.id"
          @change="select"
        />
        <label :for="c.id">
          <table>
            <tr>
                <td>
                <div :class="c.id" v-html="c.svg"> 
                </div>
                </td>
                <td width="100%"><span>{{c.text}}</span></td>
            </tr>
          </table>  
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/headerpodat'
export default {
   components:{
   Header
   },
  
   data() {
    return {
      title:"Выберите категория",
      kateg: "",
      txtkateg: "",
       arr: [
        { id: "avto",
         text: "Легковые автомобили",
         svg:"<svg width='42' height='42' viewBox='0 0 256 256'> <path fill='currentColor' d='M240 112h-10.8l-27.8-62.5a15.9 15.9 0 0 0-14.6-9.5H69.2a15.9 15.9 0 0 0-14.6 9.5L26.8 112H16a8 8 0 0 0 0 16h8v80a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-16h96v16a16 16 0 0 0 16 16h24a16 16 0 0 0 16-16v-80h8a8 8 0 0 0 0-16ZM80 160H64a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16Zm112 0h-16a8 8 0 0 1 0-16h16a8 8 0 0 1 0 16Z'/></svg>"
        },
        { id: "moto", 
         text: "Мото транспорт", 
         svg:"<svg width='42' height='42' viewBox='0 0 17 24'><path fill='currentColor' d='M8.632 15.526a2.112 2.112 0 0 0-2.106 2.105v4.305a2.106 2.106 0 0 0 4.212 0v-.043v.002v-4.263a2.112 2.112 0 0 0-2.104-2.106z'/><path fill='currentColor' d='M16.263 2.631H12.21C11.719 1.094 10.303 0 8.631 0S5.544 1.094 5.06 2.604l-.007.027h-4a1.053 1.053 0 0 0 0 2.106h4.053c.268.899.85 1.635 1.615 2.096l.016.009c-2.871.867-4.929 3.48-4.947 6.577v5.528a1.753 1.753 0 0 0 1.736 1.737h1.422v-3a3.737 3.737 0 1 1 7.474 0v3h1.421a1.752 1.752 0 0 0 1.738-1.737v-5.474a6.855 6.855 0 0 0-4.899-6.567l-.048-.012a3.653 3.653 0 0 0 1.625-2.08l.007-.026h4.053a1.056 1.056 0 0 0 1.053-1.053a1.149 1.149 0 0 0-1.104-1.105h-.002zM8.631 5.84a2.106 2.106 0 1 1 2.106-2.106l.001.06c0 1.13-.916 2.046-2.046 2.046l-.063-.001h.003z'/></svg>"
         },
        { id: "gruzspes", 
          text: "Грузовики и спецтехника",
          svg:"<svg width='42' height='42' viewBox='0 0 24 24'> <path fill='currentColor' d='M21 6.021c.003-.146-.007-1.465-1.3-2.735C18.427 2.036 17.143 2 17 2H6.996c-.239 0-1.493.063-2.708 1.302C3.036 4.578 3 5.859 3 6v3H2v3h1v6c0 .734.406 1.373 1 1.721V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h10v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.277A1.99 1.99 0 0 0 21 18v-6h1V9h-1V6.021zM9 4h6v2H9V4zM6.5 18a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 6.5 18zm4.5-5H5V8h6v5zm6.5 5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 17.5 18zm1.5-5h-6V8h6v5z'/></svg>"
         },
        { id: "zapak",
         text: "Запчасти и аксессуары",
         svg:"<svg width='42' height='42' viewBox='0 0 512 512'><path fill='currentColor' d='M256 21A235 235 0 0 0 21 256a235 235 0 0 0 235 235a235 235 0 0 0 235-235A235 235 0 0 0 256 21zm0 82c84.393 0 153 68.607 153 153s-68.607 153-153 153s-153-68.607-153-153s68.607-153 153-153zm0 18c-20.417 0-39.757 4.52-57.09 12.602C210.457 166.482 230.218 208 256 208c25.823 0 44.926-41.65 56.752-74.555C295.505 125.462 276.284 121 256 121zm98.752 42.88c-27.714 21.143-61.142 52.79-53.17 77.327c7.981 24.564 53.508 29.858 88.459 30.936c.628-5.294.959-10.678.959-16.143c0-35.642-13.755-68.012-36.248-92.12zm-197.729.243C134.663 188.204 121 220.477 121 256c0 5.55.34 11.018.988 16.39c34.833-.825 80.381-6.793 88.344-31.3c7.974-24.542-25.68-55.553-53.309-76.967zm70.188 43.643a9 9 0 0 0-5.035 1.714a9 9 0 0 0-1.99 12.57a9 9 0 0 0 12.57 1.993a9 9 0 0 0 1.992-12.572a9 9 0 0 0-7.537-3.705zm57.578 0a9 9 0 0 0-.637.004a9 9 0 0 0-6.9 3.7a9 9 0 0 0 1.992 12.573a9 9 0 0 0 12.57-1.992a9 9 0 0 0-1.99-12.57a9 9 0 0 0-5.035-1.715zM256 224a32 32 0 0 0-32 32a32 32 0 0 0 32 32a32 32 0 0 0 32-32a32 32 0 0 0-32-32zm-46.297 38.037a9 9 0 0 0-2.652.44a9 9 0 0 0-5.78 11.341a9 9 0 0 0 11.34 5.778a9 9 0 0 0 5.78-11.34a9 9 0 0 0-8.688-6.219zm92.856.008a9 9 0 0 0-8.95 6.21a9 9 0 0 0 5.78 11.34a9 9 0 0 0 11.34-5.777a9 9 0 0 0-5.78-11.341a9 9 0 0 0-2.39-.432zm-92.143 27.713c-21.59.104-50.24 16.832-72.424 31.928c19.029 34.168 52.46 59.164 92.143 66.837c9.99-33.39 18.42-78.618-2.446-93.777c-4.854-3.527-10.737-5.02-17.273-4.988zm91.016.02c-6.58 0-12.492 1.516-17.346 5.042c-20.895 15.181-11.863 60.106-2.088 93.678c39.687-7.715 73.108-32.76 92.1-66.973c-22.006-15.224-50.935-31.747-72.666-31.748zM256 295.58a9 9 0 0 0-9 9a9 9 0 0 0 9 9a9 9 0 0 0 9-9a9 9 0 0 0-9-9z'/></svg>"
        },
        { id: "drugoyt",
         text: "Другой таранспорт",
         svg:"<svg width='42' height='42' viewBox='0 0 512 512'><path fill='currentColor' d='M477.77 246.42c-2.13-6-7.23-9.55-12.56-11.95L432 221.38V92a20 20 0 0 0-20-20h-76V40a16 16 0 0 0-16-16H192a16 16 0 0 0-16 16v32h-76a20 20 0 0 0-20 20v129.46l-33.08 13.06c-5.33 2.4-10.58 6-12.72 12s-3.16 11.81-1 19L84.25 415.7h1.06c34.12 0 64-17.41 85.31-43.82c21.32 26.41 51.18 42.12 85.3 42.12s64-15.76 85.31-42.17c21.32 26.41 51.18 43.87 85.3 43.87h1.06l51.25-150.17c2.16-6 1.07-13.1-1.07-19.11ZM256 152l-144 56.83V108a4 4 0 0 1 4-4h280a4 4 0 0 1 4 4v100.76Z'/><path fill='currentColor' d='M345.22 407c-52.25 36.26-126.35 36.25-178.6 0c0 0-45.64 63-94.64 63l13.33 1c29.86 0 58.65-11.73 85.31-25.59a185.33 185.33 0 0 0 170.6 0c26.66 13.87 55.45 25.6 85.31 25.6l13.33-1C392.21 470 345.22 407 345.22 407Z'/></svg>"
        },
        { id: "remus", 
        text: "Ремонт и услуги",
        svg:"<svg width='42' height='42' viewBox='0 0 512 512'><path fill='currentColor' d='m241.406 21l-15.22 34.75a182.242 182.242 0 0 0-23.467 2.97l-23.282-30.064l-25.094 8.532l-.125 38.25c-10.63 5.464-20.817 12.07-30.44 19.78L88.313 79.25L70.156 98.563L88.312 133a180.58 180.58 0 0 0-15.218 26.094l-38.938 1.062l-7.906 25.28l31.438 23.158c-1.505 9.38-2.24 18.858-2.282 28.344L20.5 254.625l3.656 26.25l38.313 7.5a181.6 181.6 0 0 0 8.5 23.5L45.72 343.22l14.093 22.436l39.25-9.187a185.132 185.132 0 0 0 7.718 8.53a187.386 187.386 0 0 0 17.72 16.125l-7.625 39.313l22.938 13.25l29.968-26.094a179.393 179.393 0 0 0 26.407 8.312l9.782 38.406l26.405 2.157l15.875-36.22c10.97-.66 21.904-2.3 32.656-4.938l25.22 29.22l24.593-9.844l-.72-14.813l-57.406-43.53c-16.712 4.225-34.042 5.356-51.063 3.436c-31.754-3.58-62.27-17.92-86.218-42.686c-54.738-56.614-53.173-146.67 3.438-201.406c27.42-26.513 62.69-39.963 98-40.344c37.59-.406 75.214 13.996 103.438 43.187c45.935 47.512 52.196 118.985 19.562 173.095l31.97 24.25a181.443 181.443 0 0 0 10.75-19.375l38.655-1.063l7.906-25.28l-31.217-23a183.327 183.327 0 0 0 2.28-28.594l34.688-17.625l-3.655-26.25l-38.28-7.5a181.934 181.934 0 0 0-12.75-32.125l22.81-31.594l-15.25-21.657l-37.56 10.906c-.472-.5-.93-1.007-1.408-1.5a184.77 184.77 0 0 0-18.937-17.064l7.188-37.125L334 43.78l-28.5 24.814c-9.226-3.713-18.702-6.603-28.313-8.75l-9.343-36.688L241.406 21zM183.25 174.5c-10.344.118-20.597 2.658-30 7.28l45.22 34.314c13.676 10.376 17.555 30.095 7.06 43.937c-10.498 13.85-30.656 15.932-44.53 5.408l-45.188-34.282c-4.627 24.793 4.135 51.063 25.594 67.344c19.245 14.597 43.944 17.33 65.22 9.688l4.78-1.72l4.03 3.063l135.19 102.564l4.03 3.062l-.344 5.063c-1.637 22.55 7.59 45.61 26.844 60.217c21.46 16.28 49.145 17.63 71.78 6.5l-45.186-34.28c-13.874-10.526-17.282-30.506-6.78-44.344c10.5-13.84 30.537-15.405 44.217-5.032l45.188 34.283c4.616-24.784-4.11-51.067-25.563-67.344c-19.313-14.658-43.817-17.562-64.968-10.033l-4.75 1.688l-4.03-3.063l-135.19-102.562l-4.03-3.063l.344-5.03c1.55-22.387-7.85-45.194-27.157-59.845c-12.544-9.516-27.222-13.978-41.78-13.812zm43.563 90.25l163.875 124.344L379.406 404L215.5 279.625l11.313-14.875z'/></svg>"
        },
      ],
    };
  },
  methods: {
    select() {
        const values = Object.values(this.arr);
        for (let i = 0; i < values.length; i += 1) {
          if (values[i].id === this.kateg) this.txtkateg = values[i].text;
        }
        this.$store.commit("addpodatkateg",this.kateg);
        this.$store.commit("addpodatkateg_text",this.txtkateg);
        this.$store.commit("addpodatpodkateg","");
        this.$store.commit("addpodatpodkateg_text","");
        this.dale();

    },
    dale() {
      if(this.kateg=="avto" || this.kateg=="moto"  ) {
         this.$router.push({name:"marka", params:{id:this.kateg}});
      }
       else {
      this.$router.push({name:"podkateg", params:{id:this.kateg}});
     }
    },
   
  },
  computed: {
    getkateg() {
      return this.$store.getters.getpodatkateg;
    },
   },
  created() {
    if (!localStorage.getItem("token")) {
       this.$router.go(-1); 
      } 
  },
  mounted (){
    if(this.getkateg){
      this.kateg=this.getkateg;
    }
  }
};
</script>
<style scoped>
.block_radio {
  margin-bottom: 1.4em;
}
.divgorod {
  width: 100%;
  color: #777777;
}
.contentgorod {
  font-size: 20px;
  border-bottom: 1px solid #000000;
  padding: 5px 5px 5px 0px;
}
label {
  font-size: 18px;
  width: 100%;
}
.content_podat {
  padding: 90px 5px 65px 10px;
}
</style>